import * as React from "react";
import cn from "clsx";
import { Icon } from "../icon";

export type InputProps = {
  iconName?: "search" | "calendar";
  errorMessage?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const InputField = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className,iconName, errorMessage, type, ...props }, ref) => {

    return (
      <span className={cn("in-input__wrapper")}>
      {iconName && (<Icon iconName={iconName} prefix="fasr" size="xs" className={cn("in-input__icon")} />)}
      <input
        type={type}
        className={cn("in-input__input", iconName && "in-input__icon-left", errorMessage && "in-input__error", className)}
        ref={ref}
        {...props}
      />
      </span>
    );
  }
);

export { InputField };
